export default "__VITE_ASSET__D3a_bXtJ__ 480w, __VITE_ASSET__nvStPsNK__ 768w, __VITE_ASSET__JdVeVACQ__ 1024w, __VITE_ASSET__CpLjtVW$__ 1184w";